module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('a', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": _vm.emitirSegundaVia
    }
  }, [_vm._v("Emitir GRV")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right no-padder"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.emitirSegundaVia
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" Emitir GRV Completa")])]), _vm._v(" "), (_vm.grv.status > 99 && _vm.grv.status < 200) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$emit('emitirDocumentoRetirada', _vm.grv)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" Emitir PDF Retirada")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$emit('openDeclaracaoAcessoVeiculo', _vm.grv)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" Declaração de Acesso ao Veículo")])]), _vm._v(" "), (_vm.arquivoScanGrv) ? _c('li', [_c('a', {
    on: {
      "click": _vm.downloadDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" Emitir Scan GRV")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "separator"
  }), _vm._v(" "), _c('li', [(_vm.ACL.check('criar_ggv_policia', _vm.currentUser.id)) ? _c('a', {
    on: {
      "click": _vm.criarGgv
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o m-r-xs"
  }), _vm._v(" Vistoria (GGV)")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.openRetirada
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o m-r-xs"
  }), _vm._v(" Retirada (GEV)")])]), _vm._v(" "), _c('li', {
    staticClass: "separator"
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$emit('verHistoricoDeLeiloes', _vm.grv)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel"
  }), _vm._v(" Histórico de Leilões")])]), _vm._v(" "), (_vm.isAdministradorExclusivo || _vm.currentUser.id === 1570 || _vm.possuiACL('bloquear_grv_para_leilao')) ? _c('li', [_c('a', {
    on: {
      "click": _vm.bloquearParaLeilao
    }
  }, [_c('span', {
    class: {
      'text-danger': !_vm.grv.bloqueadoParaLeilao
    }
  }, [_c('i', {
    class: ("fa fa-" + (_vm.grv.bloqueadoParaLeilao ? 'check' : 'ban'))
  }), _vm._v(" " + _vm._s(_vm.grv.bloqueadoParaLeilao ? 'Desbloquear ' : 'Bloquear') + " para leilões\n        ")])])]) : _vm._e(), _vm._v(" "), _c('li', [(_vm.podeExcluirGrv) ? _c('a', {
    staticClass: "text-danger",
    on: {
      "click": _vm.deleteGrv
    }
  }, [_vm._m(0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Excluir GRV")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dce700f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/roubo-furto/components/BtnAcaoListaGrvRouboFurto.vue
// module id = 1697
// module chunks = 17